import { Badge } from "@/components/ui/badge";
import { getSiteTypeStyles } from "@/lib/table-styles";
import { cn } from "@/lib/utils";

interface SiteTypeBadgeProps {
  siteType: string | null | undefined;
  className?: string;
}

export const SiteTypeBadge = ({ siteType, className }: SiteTypeBadgeProps) => {
  const label = siteType?.trim();
  if (!label) return null;

  return (
    <Badge
      variant="secondary"
      className={cn(
        "text-[10px] h-4 px-1 hover:opacity-90",
        getSiteTypeStyles(label),
        className,
      )}
    >
      {label}
    </Badge>
  );
};
